export const shuffleArray = (array) => {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};

export const handleShuffle = (shuffled, selectedCertification, cards, setCards, setShuffled, setCurrentCardIndex) => {
  if (shuffled) {
    const module = import(`../../data/${selectedCertification.dataFile}`);
    module.then(mod => {
      setCards(mod.default);
      setShuffled(false);
      setCurrentCardIndex(0);
    });
  } else {
    setCards(shuffleArray(cards));
    setShuffled(true);
    setCurrentCardIndex(0);
  }
};

export const handleNext = (currentCardIndex, cards, setCurrentCardIndex) => {
  if (currentCardIndex < cards.length - 1) {
    setCurrentCardIndex(currentCardIndex + 1);
  }
};

export const handlePrevious = (currentCardIndex, setCurrentCardIndex) => {
  if (currentCardIndex > 0) {
    setCurrentCardIndex(currentCardIndex - 1);
  }
};

export const handleReset = (setCurrentCardIndex) => {
  setCurrentCardIndex(0);
};
